module.exports = __webpack_public_path__ + "static/media/thumb.ca80b40a.png";